import { Button } from "@/components/ui/button";
const heroImage = "/images/ebikeandco-landes-velos-vacances-43.webp";
import { MapPin, Star } from "lucide-react";
import { useLocations } from "@/lib/use-locations";

const HeroSection = () => {
  const locations = useLocations();
  return (
    <section className="bg-background">
      <div className="container-narrow px-4 md:px-8 lg:px-16 pt-12 pb-6 md:pt-20 md:pb-10">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="md:text-4xl lg:text-5xl font-extrabold text-foreground leading-tight mb-4 text-5xl">
              Réservez vos vélos{" "}
              <span className="text-primary">dans les Landes</span>{" "}
              cet été !

            </h1>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              {locations.length} points de location à votre dispo pour des vacances sans galère !
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <Button size="lg" asChild>
                <a href="#etablissements">
                  <MapPin className="w-5 h-5" />
                  Choisir mon point de location
                </a>
              </Button>
            </div>

            {/* Social proof mini */}
            <div className="mt-8 flex items-center gap-2">
              <span className="text-2xl font-extrabold text-foreground">4.9</span>
              <span className="text-sm text-muted-foreground">sur</span>
              <span className="font-bold text-foreground text-lg">G</span>
              <div className="flex gap-0.5">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star key={i} className="w-5 h-5" style={{ color: "hsl(var(--warm))", fill: "hsl(var(--warm))" }} />
                ))}
              </div>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden">
            <img
              src={heroImage}
              alt="Famille à vélo sur les pistes cyclables des Landes"
              width={750}
              height={420}
              fetchPriority="high"
              decoding="async"
              loading="eager"
              sizes="(max-width: 768px) 100vw, 50vw"
              className="w-full h-[320px] md:h-[420px] object-cover rounded-2xl" />
            
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;